/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This service delivers the **timetable-based public transportation routing** used across SBB’s journey-planning channels, including [sbb.ch](https://www.sbb.ch/) and the [SBB Mobile](https://apps.apple.com/ch/app/sbb-mobile/id294855237) app.   This API is provided **exclusively to SBB internal stakeholders and accredited partners**. Organizations without SBB affiliation are encouraged to use the [Open Journey Planner (OJP)](https://opentransportdata.swiss/en/cookbook/open-journey-planner-ojp/), accessible through the [Open Transport Data](https://opentransportdata.swiss/en/) portal.  ### Approval Process   #### Step 1 Sign up below, complete the required account fields and confirm your registration.  #### Step 2 * **Internal** (SBB employees): Open and complete the [questionnaire](https://sbb.sharepoint.com/:b:/s/journey/IQAz0q3KNhLsRoMwqBu58p6RAawc_K4SUFJGp6xEgVTHsOw?e=RkWuxv), then email it to us (see \'Contact -> E-Mail\') with the exact subject line **Request: Sign Up Journey-Service**.  * **External** (third-party companies): Request the questionnaire by sending us an e-mail (see \'Contact -> E-Mail\').  With all the information in hand, a decision to approve/reject the request will be made and you will be notified accordingly.   ### Approved consumers * Please consult the [**Developer resources**](https://github.com/SchweizerischeBundesbahnen/journey-service/tree/master) for detailed information on Journey-Service concepts, usage, and debugging. * Further details about each endpoint are available in the **Documentation** section of this website. * For release notes, please refer to the **Blog** section on this website.  For further questions, contact us via e-mail (see \'Contact -> E-Mail\').  
 *
 * The version of the OpenAPI document: 3.37.1
 * Contact: journey@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { FacilityForInfoPortalResponse } from '../model/models';
import { InheritanceResponse } from '../model/models';
import { PlaceRelationTypeEnum } from '../model/models';
import { PlaceResponse } from '../model/models';
import { Problem } from '../model/models';
import { StopPlaceDetailed } from '../model/models';
import { StopPlaceDetailedResponse } from '../model/models';
import { VehicleModeEnum } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class PlacesV3Service {

    protected basePath = 'https://journey-service.api.sbb.ch';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * PATCH for OpenApi-Plugin-Generator (temporary).
     * ApiClient **inherited sub-classes** reference.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public getDummyInheritance(requestID?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<InheritanceResponse>;
    public getDummyInheritance(requestID?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<InheritanceResponse>>;
    public getDummyInheritance(requestID?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<InheritanceResponse>>;
    public getDummyInheritance(requestID?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<InheritanceResponse>(`${this.configuration.basePath}/v3/INCUBATOR/openapi/dummy-patch`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the facility as for InfoPortal.
     * Get the facility as for InfoPortal. Temporary solution before it goes to a PlaceService. 
     * @param id &#x60;StopPlace::id&#x60; from a /places or /stopPlaces request. Currently UIC values greater 0 and Integer.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFacilityForInfoPortal(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<FacilityForInfoPortalResponse>;
    public getFacilityForInfoPortal(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<FacilityForInfoPortalResponse>>;
    public getFacilityForInfoPortal(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<FacilityForInfoPortalResponse>>;
    public getFacilityForInfoPortal(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getFacilityForInfoPortal.');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<FacilityForInfoPortalResponse>(`${this.configuration.basePath}/v3/stop-places/${encodeURIComponent(String(id))}/facility-info-portal`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get places nearby given coordinates by longitude/latitude. (Alternately use &#x60;v3/places/by-coordinates-geojson&#x60; instead.)
     * Returns a list of &#x60;Place\&#39;s&#x60; ordered by their distance to the centre coordinates.
     * @param longitude Longitude as decimal WGS84, paired with &#x60;latitude&#x60;.
     * @param latitude Latitude as decimal WGS84, paried with &#x60;longitude&#x60;.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param radius Radius [m] around the given coordinate &#x60;longitude/latitude&#x60;.
     * @param limit Number of hits to be found (max&#x3D;50).
     * @param type Place type to be searched for.
     * @param includeVehicleModes Whether to deliver the &#x60;StopPlace::vehicleModes&#x60; or not.   This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlacesByCoordinates(longitude: number, latitude: number, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<PlaceResponse>;
    public getPlacesByCoordinates(longitude: number, latitude: number, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<PlaceResponse>>;
    public getPlacesByCoordinates(longitude: number, latitude: number, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<PlaceResponse>>;
    public getPlacesByCoordinates(longitude: number, latitude: number, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (longitude === null || longitude === undefined) {
            throw new Error('Required parameter longitude was null or undefined when calling getPlacesByCoordinates.');
        }
        if (latitude === null || latitude === undefined) {
            throw new Error('Required parameter latitude was null or undefined when calling getPlacesByCoordinates.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (longitude !== undefined && longitude !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>longitude, 'longitude');
        }
        if (latitude !== undefined && latitude !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>latitude, 'latitude');
        }
        if (radius !== undefined && radius !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>radius, 'radius');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (type) {
            type.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'type');
            })
        }
        if (includeVehicleModes !== undefined && includeVehicleModes !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeVehicleModes, 'includeVehicleModes');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PlaceResponse>(`${this.configuration.basePath}/v3/places/by-coordinates`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get places nearby given coordinates in GeoJson. (Alternately use &#x60;v3/places/by-coordinates&#x60; instead.)
     * Returns a list of &#x60;Place\&#39;s&#x60; ordered by their distance to the centre coordinates.
     * @param center Search nearby within related &#x60;radius&#x60; of: A representative geographic position of the &#x60;Place&#x60; by a [GeoJSON Point](https://datatracker.ietf.org/doc/html/rfc794).
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param radius Radius [m] around the given &#x60;center&#x60;.
     * @param limit Number of hits to be found (max&#x3D;50).
     * @param type Place type to be searched for.
     * @param includeVehicleModes Whether to deliver the &#x60;StopPlace::vehicleModes&#x60; or not.   This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlacesByCoordinatesGeojson(center: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<PlaceResponse>;
    public getPlacesByCoordinatesGeojson(center: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<PlaceResponse>>;
    public getPlacesByCoordinatesGeojson(center: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<PlaceResponse>>;
    public getPlacesByCoordinatesGeojson(center: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', radius?: number, limit?: number, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, includeVehicleModes?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (center === null || center === undefined) {
            throw new Error('Required parameter center was null or undefined when calling getPlacesByCoordinatesGeojson.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (center !== undefined && center !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>center, 'center');
        }
        if (radius !== undefined && radius !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>radius, 'radius');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (type) {
            type.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'type');
            })
        }
        if (includeVehicleModes !== undefined && includeVehicleModes !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeVehicleModes, 'includeVehicleModes');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PlaceResponse>(`${this.configuration.basePath}/v3/places/by-coordinates-geojson`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get places of type StopPlace, Address,PointOfInterest by its name.
     * The response is a flat (non-inherited) structure of concrete places. &lt;br/&gt;The response can be cached during 3 minutes.
     * @param nameMatch Tolerant &#x60;Place::name&#x60; match, where &#x60;Accept-Language&#x60; accepts translated terms like (Genève, Geneva, ..) at request time, where: - Address resp. street name (like \&#39;Bollwerk 8\&#39;) - PointOfInterest (like \&#39;Museum\&#39;) - StopPlace name (like \&#39;Bern\&#39; or DiDok-UIC \&#39;8507000\&#39; or DiDok-ShortName \&#39;BN\&#39;).
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param ifNoneMatch An optional ETag given in a previous response header _ETag_ and which can save traffic network. See [J-S caching](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/technical/TechnicalAspects.md#caching)
     * @param type &#x60;Place::type&#x60; to be searched for.
     * @param limit Number of hits to be found (max&#x3D;50).
     * @param center A representative geographic position of the &#x60;Place&#x60; by a [GeoJSON Point](https://datatracker.ietf.org/doc/html/rfc794). If set, the pattern matching score of &#x60;nameMatch&#x60; in the specified &#x60;radius&#x60; is increased though outside hits may still be contained if they reach a high pattern score as well.&lt;br&gt;To find all stops in a circle-region use v3/places/by-coordinates-geojson instead.)  This parameter has an impact on performance and/or response volume, set wisely!
     * @param radius Radius [m] around the related &#x60;center&#x60;, if given.
     * @param includeVehicleModes Whether to deliver the &#x60;StopPlace::vehicleModes&#x60; or not.   This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeTouristicVia If &#x60;type&#x60; contain &#x60;StopPlace&#x60; also include touristic via (pseudo stop-markers relevant for routing) like \&#39;Centovalli\&#39; or \&#39;Bahn-2000-Strecke\&#39; if set to true.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlacesByName(nameMatch: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, limit?: number, center?: string, radius?: number, includeVehicleModes?: boolean, includeTouristicVia?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<PlaceResponse>;
    public getPlacesByName(nameMatch: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, limit?: number, center?: string, radius?: number, includeVehicleModes?: boolean, includeTouristicVia?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<PlaceResponse>>;
    public getPlacesByName(nameMatch: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, limit?: number, center?: string, radius?: number, includeVehicleModes?: boolean, includeTouristicVia?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<PlaceResponse>>;
    public getPlacesByName(nameMatch: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, type?: Array<'ALL' | 'StopPlace' | 'Address' | 'PointOfInterest'>, limit?: number, center?: string, radius?: number, includeVehicleModes?: boolean, includeTouristicVia?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (nameMatch === null || nameMatch === undefined) {
            throw new Error('Required parameter nameMatch was null or undefined when calling getPlacesByName.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (nameMatch !== undefined && nameMatch !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nameMatch, 'nameMatch');
        }
        if (type) {
            type.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'type');
            })
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (center !== undefined && center !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>center, 'center');
        }
        if (radius !== undefined && radius !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>radius, 'radius');
        }
        if (includeVehicleModes !== undefined && includeVehicleModes !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeVehicleModes, 'includeVehicleModes');
        }
        if (includeTouristicVia !== undefined && includeTouristicVia !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeTouristicVia, 'includeTouristicVia');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }
        if (ifNoneMatch !== undefined && ifNoneMatch !== null) {
            headers = headers.set('If-None-Match', String(ifNoneMatch));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PlaceResponse>(`${this.configuration.basePath}/v3/places`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the &#x60;StopPlaceDetailed&#x60; (aka stations, bus stops, etc.) known resp. routed by public transportation.
     * Get the stop place by its id. All Stations will be updated on a weekly base, because of rare changes, please do not use this service too frequently! &lt;br/&gt;The response can be cached during 1 day.
     * @param id &#x60;StopPlace::id&#x60; from a /places or /stopPlaces request. Currently UIC (1-7 digits) and SLOID supported.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param ifNoneMatch An optional ETag given in a previous response header _ETag_ and which can save traffic network. See [J-S caching](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/technical/TechnicalAspects.md#caching)
     * @param date &#x60;StopPlace&#x60; snapshot for the related &#x60;date&#x60; (defaults to TODAY). If &#x60;StopPlace&#x60; is available for another date, check &#x60;Problem::detail&#x60;.
     * @param includeRelations Which place-to-place relation type should be returned. If not needed, **please give &#x60;NONE&#x60;**. Default for backward compatibility: &#x60;LEADER, MEMBERS&#x60;. Possible values: - &#x60;NONE&#x60; fills none of the following fields, - &#x60;LEADER&#x60; fills the field &#x60;StopPlaceDetailed::leader&#x60;, - &#x60;MEMBERS&#x60; fills the field &#x60;StopPlaceDetailed::members&#x60;, - &#x60;ACCESSES_FROM&#x60; fills the field &#x60;StopPlaceDetailed::accessesFrom&#x60;, - &#x60;ACCESSES_TO&#x60; fills the field &#x60;StopPlaceDetailed::accessesTo&#x60;.  This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStopPlaceById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, includeRelations?: Array<PlaceRelationTypeEnum>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<StopPlaceDetailed>;
    public getStopPlaceById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, includeRelations?: Array<PlaceRelationTypeEnum>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<StopPlaceDetailed>>;
    public getStopPlaceById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, includeRelations?: Array<PlaceRelationTypeEnum>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<StopPlaceDetailed>>;
    public getStopPlaceById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, includeRelations?: Array<PlaceRelationTypeEnum>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getStopPlaceById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (includeRelations) {
            includeRelations.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'includeRelations');
            })
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }
        if (ifNoneMatch !== undefined && ifNoneMatch !== null) {
            headers = headers.set('If-None-Match', String(ifNoneMatch));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<StopPlaceDetailed>(`${this.configuration.basePath}/v3/stop-places/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the matching &#x60;StopPlaceDetailed&#x60; (aka stations, bus stops, etc.) known resp. routed by public transportation.
     *  Provides a download of all transferable &#x60;StopPlaceDetailed&#x60; known by Atlas (UIC source) resp. INFO+ (planned routes).&lt;br&gt;There are more than 65\&#39;000 such entries.&lt;br&gt;{To compress large responses, set header &#x60;accept-encoding&#x60; as &#x60;gzip&#x60;.}&lt;br&gt;All Stations will be updated on a weekly base, because of rare changes, please do not use this service too frequently! &lt;br/&gt;The response can be cached during 1 day.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param ifNoneMatch An optional ETag given in a previous response header _ETag_ and which can save traffic network. See [J-S caching](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/technical/TechnicalAspects.md#caching)
     * @param countryCode Atlas\&#39;s geographical country: optionally restrict hits to a specific country by 2-letter format ISO 3166 as per [https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
     * @param sortOrder Sort sortOrder of StopPlaces if given: alphabetically by name, by weight/importance or by distance (only if _nearby_ is set).
     * @param validDate StopPlace data might change over time (though not very often) for an exact **snapshot-date** (defaults to TODAY or set null if &#x60;validFrom/To&#x60; are set).
     * @param validFrom Only find &#x60;StopPlace\&#39;s&#x60; that are valid within an interval, relates to &#x60;validTo&#x60;. May result in multiple instances of \&#39;same\&#39; &#x60;StopPlace&#x60; with identical &#x60;id&#x60;.
     * @param validTo Only find &#x60;StopPlace\&#39;s&#x60; that are valid within an interval, relates to &#x60;validFrom&#x60;. May result in multiple instances of \&#39;same\&#39; &#x60;StopPlace&#x60; with identical &#x60;id&#x60;.
     * @param vehicleModes Restrict to StopPlaces served by the given vehcile main modes, null or empty for any. Be aware the known vehicle-modes are based on planned calculated routes and might not match exactly in realtime.
     * @param nameMatch Tolerant &#x60;Place::name&#x60; match, where &#x60;Accept-Language&#x60; accepts translated terms like (Genève, Geneva, ..) at request time, where: - Address resp. street name (like \&#39;Bollwerk 8\&#39;) - PointOfInterest (like \&#39;Museum\&#39;) - StopPlace name (like \&#39;Bern\&#39; or DiDok-UIC \&#39;8507000\&#39; or DiDok-ShortName \&#39;BN\&#39;).
     * @param nearby Reference point for searching nearby stop places (reduces hits in a meaningful way). See v3 _PlaceReference_ in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @param limit Limit the number of returned elements (empty for no limit).  This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeRelations Which place-to-place relation type should be returned. If not needed, **please give &#x60;NONE&#x60;**. Default for backward compatibility: &#x60;LEADER, MEMBERS&#x60;. Possible values: - &#x60;NONE&#x60; fills none of the following fields, - &#x60;LEADER&#x60; fills the field &#x60;StopPlaceDetailed::leader&#x60;, - &#x60;MEMBERS&#x60; fills the field &#x60;StopPlaceDetailed::members&#x60;, - &#x60;ACCESSES_FROM&#x60; fills the field &#x60;StopPlaceDetailed::accessesFrom&#x60;, - &#x60;ACCESSES_TO&#x60; fills the field &#x60;StopPlaceDetailed::accessesTo&#x60;.  This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStopPlaces(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, countryCode?: string, sortOrder?: 'NAME' | 'WEIGHT' | 'DISTANCE', validDate?: string, validFrom?: string, validTo?: string, vehicleModes?: Array<VehicleModeEnum>, nameMatch?: string, nearby?: string, limit?: number, includeRelations?: Array<PlaceRelationTypeEnum>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<StopPlaceDetailedResponse>;
    public getStopPlaces(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, countryCode?: string, sortOrder?: 'NAME' | 'WEIGHT' | 'DISTANCE', validDate?: string, validFrom?: string, validTo?: string, vehicleModes?: Array<VehicleModeEnum>, nameMatch?: string, nearby?: string, limit?: number, includeRelations?: Array<PlaceRelationTypeEnum>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<StopPlaceDetailedResponse>>;
    public getStopPlaces(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, countryCode?: string, sortOrder?: 'NAME' | 'WEIGHT' | 'DISTANCE', validDate?: string, validFrom?: string, validTo?: string, vehicleModes?: Array<VehicleModeEnum>, nameMatch?: string, nearby?: string, limit?: number, includeRelations?: Array<PlaceRelationTypeEnum>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<StopPlaceDetailedResponse>>;
    public getStopPlaces(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, countryCode?: string, sortOrder?: 'NAME' | 'WEIGHT' | 'DISTANCE', validDate?: string, validFrom?: string, validTo?: string, vehicleModes?: Array<VehicleModeEnum>, nameMatch?: string, nearby?: string, limit?: number, includeRelations?: Array<PlaceRelationTypeEnum>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (countryCode !== undefined && countryCode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>countryCode, 'countryCode');
        }
        if (sortOrder !== undefined && sortOrder !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sortOrder, 'sortOrder');
        }
        if (validDate !== undefined && validDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>validDate, 'validDate');
        }
        if (validFrom !== undefined && validFrom !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>validFrom, 'validFrom');
        }
        if (validTo !== undefined && validTo !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>validTo, 'validTo');
        }
        if (vehicleModes) {
            vehicleModes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'vehicleModes');
            })
        }
        if (nameMatch !== undefined && nameMatch !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nameMatch, 'nameMatch');
        }
        if (nearby !== undefined && nearby !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nearby, 'nearby');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (includeRelations) {
            includeRelations.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'includeRelations');
            })
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }
        if (ifNoneMatch !== undefined && ifNoneMatch !== null) {
            headers = headers.set('If-None-Match', String(ifNoneMatch));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<StopPlaceDetailedResponse>(`${this.configuration.basePath}/v3/stop-places`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
